(() => {
  if (customElements.get('product-media')) {
    return;
  }

  class ProductMedia extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        mainSlider: '[data-main-product-slider]',
        thumbsSlider: '[data-main-product-thumbs]',
        progressBar: '[data-main-product-slider-progress-bar]',
        modalOpeners: '[data-modal-opener-id]',
        zoomImages: '[data-pswp-image]',
        btnXr: '[data-shopify-xr]',
        deferredMedia: 'deferred-media[data-autoplay]',
        iframe: 'iframe',
        youtube: '.js-youtube',
        vimeo: '.js-vimeo',
        closeIcon: '[data-close-icon]',
        prevIcon: '[data-prev-icon]',
        nextIcon: '[data-next-icon]',
        thumbNextButton: '[data-thumbs-next]',
        thumbPrevButton: '[data-thumbs-prev]',
        mobileNavigation: '.main-product__media-controls-mobile-navigation'
      };

      this.mainSliderElement = this.querySelector(this.selectors.mainSlider);
      this.mainSliderDrag = Number(this.mainSliderElement.dataset.slidesCount) !== 1;
      this.autoHeight = this.hasAttribute('data-autoheight');

      this.mainSliderMobileLayout = document.querySelector('.main-product__media-mobile-carousel');

      var mainSliderPerView = 1;
      var mainSliderSpacing = 0;

      if(this.mainSliderMobileLayout) {
        var mainSliderPerView = 1.1;
        var mainSliderSpacing = 4;
      }

      this.settings = {
        mainSlider: {
          element: this.mainSliderElement,
          instance: null,
          options: {
            loop: true,
            spaceBetween: mainSliderSpacing,
            slidesPerView: mainSliderPerView,
            pagination: {
              el: '.main-product__media-progress',
              type: "progressbar",
            },
            allowTouchMove: this.mainSliderDrag,
            autoHeight: this.autoHeight,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
              990: {
                slidesPerView: 1,
                spaceBetween: 0
              }
            },
            thumbs: {
              swiper: null
            }
          }
        },
        thumbsSlider: {
          element: this.querySelector(this.selectors.thumbsSlider),
          instance: null,
          options: {
            spaceBetween: 16,
            slidesPerView: 4,
            direction: 'vertical',
            freeMode: true,
            loop: false,
            watchSlidesProgress: true,
            navigation: {
              nextEl: this.querySelector(this.selectors.thumbNextButton),
              prevEl: this.querySelector(this.selectors.thumbPrevButton),
            }
          }
        }
      };

      window.addEventListener('DOMContentLoaded', this.initSlider.bind(this));
      window.addEventListener('resize', this.initSlider.bind(this));
    }

    connectedCallback() {
      this.initSlider();

      document.body.addEventListener('touchstart', () => {
        this.querySelectorAll(this.selectors.deferredMedia).forEach((media) => {
          const iframe = media.querySelector(this.selectors.iframe);

          if (!iframe) return;

          if (iframe.classList.contains('js-youtube')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
          }

          if (iframe.classList.contains('js-vimeo')) {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
          }
        })
      }, { once: true });

      this.initPhotoSwipe();
    }

    initSlider() {
      if (window.innerWidth >= 990 && !this.mainSliderElement.hasAttribute('data-main-slider-desktop')) {
        this.mainSliderElement.classList.add('is-initialized');

        if (this.settings.mainSlider.instance) {
          this.settings.mainSlider.instance.destroy(true, true);
          this.settings.mainSlider.instance = null;
        }

        return;
      }

      if (this.settings.mainSlider.instance) {
        return;
      }

      if (this.settings.thumbsSlider.element) {
        this.settings.thumbsSlider.instance = new Swiper(
          this.settings.thumbsSlider.element,
          this.settings.thumbsSlider.options
        );
      }

      this.settings.mainSlider.instance = new Swiper(
        this.settings.mainSlider.element,
        {
          ...this.settings.mainSlider.options,
          navigation: {
            nextEl: '.main-product__media-next',
            prevEl: '.main-product__media-prev'
          },
          thumbs: {
            swiper: this.settings.thumbsSlider.instance
          },
          on: {
            init: (swiper) => {
              if (document.querySelector(this.selectors.mobileNavigation)) {
                const counterElement = document.querySelector('.main-product__media-counter');
                if (counterElement) {
                  const currentSlideElement = counterElement.querySelector('#main-product__current-slide');
                  const totalSlidesElement = counterElement.querySelector('#main-product__total-slides');

                  const updateSlideCounter = () => {
                    currentSlideElement.textContent = swiper.realIndex + 1;
                    totalSlidesElement.textContent = swiper.slides.length;
                  };

                  updateSlideCounter();
                  swiper.on('slideChange', updateSlideCounter);
                }
              }
            }
          }
        }
      );

      // Watch for changes in the main slider and update the thumb slider
      this.settings.mainSlider.instance.on('slideChange', () => {
        const index = this.settings.mainSlider.instance.realIndex;
        if (this.settings.thumbsSlider.instance) {
          this.settings.thumbsSlider.instance.slideTo(index);

          this.updateThumbActiveClass(index);
        }
      });

      // Watch for changes in the thumb slider and update the main slider
      if (this.settings.thumbsSlider.instance) {
        this.settings.thumbsSlider.instance.on('click', (swiper) => {
          const clickedIndex = swiper.clickedIndex;
          if (typeof clickedIndex !== 'undefined' && clickedIndex !== null) {
            this.settings.mainSlider.instance.slideToLoop(clickedIndex);

            this.updateThumbActiveClass(clickedIndex);
          }
        });
      }

      if (this.autoHeight) {
        this.settings.mainSlider.instance.on('slideChangeTransitionEnd', () => {
          this.changeListHeight(
            this.settings.mainSlider.instance.el,
            this.settings.mainSlider.instance.slides
          );
        });
      }
    }

    updateThumbActiveClass(activeIndex) {
      const thumbSlides = this.settings.thumbsSlider.element.querySelectorAll('.swiper-slide');
      thumbSlides.forEach(slide => slide.classList.remove('swiper-slide-active'));
      if (thumbSlides[activeIndex]) {
        thumbSlides[activeIndex].classList.add('swiper-slide-active');
      }
    }

    changeListHeight(rootEl, slides) {
      rootEl.querySelector('.swiper-wrapper').style.height =
        `${slides[this.settings.mainSlider.instance.realIndex].offsetHeight}px`;
    }

    goToSlide(mediaId) {
      if (!this.settings.mainSlider.instance) {
        const media = this.settings.mainSlider.element.querySelector(`[data-media-id="${mediaId}"]`);

        if (!media) {
          return;
        }

        media.scrollIntoView({
          behavior: 'smooth'
        });

        return;
      }

      const slideIndex = Array.from(this.settings.mainSlider.instance.slides).findIndex((slide) => (
        Number(slide.dataset.mediaId) === mediaId
      ));

      this.settings.mainSlider.instance.slideTo(slideIndex);
    }

    initPhotoSwipe() {
      const [
        zoomContainerWidth,
        zoomContainerHeight,
        closeIcon,
        prevIcon,
        nextIcon
      ] = [
        this.offsetWidth,
        this.offsetHeight,
        this.querySelector(this.selectors.closeIcon),
        this.querySelector(this.selectors.prevIcon),
        this.querySelector(this.selectors.nextIcon)
      ];

      const isPhone = () => window.innerWidth < 750;

      const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
        gallery: `#${this.settings.mainSlider.element.id}`,
        children: 'a',
        mainClass: 'pswp--product-media-gallery',
        loop: false,
        showHideAnimationType: 'zoom',
        initialZoomLevel: zoomLevelObject => isPhone() ? zoomLevelObject.vFill : zoomLevelObject.fit,
        secondaryZoomLevel: zoomLevelObject => isPhone() ? zoomLevelObject.fit : 1,
        pswpModule: PhotoSwipe
      });

      photoSwipeLightboxInstance.addFilter('itemData', (itemData, index) => {
        if (itemData.type === 'html' && itemData.element) {
          return { html: itemData.element.dataset.pswpHtml };
        }
        return itemData;
      });

      photoSwipeLightboxInstance.init();

      photoSwipeLightboxInstance.on('beforeOpen', () => {
        const videos = this.querySelectorAll('video');
        Array.from(videos).forEach(video => {
          video.play().then(() => {
            // Automatic playback started!
          }).catch(error => {
            video.pause();
          });
        });
      });
    }
  }

  customElements.define('product-media', ProductMedia);

})();
